import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { AppService } from '../app.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    private app: AppService;

    constructor(private injector: Injector) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let requestToForward = req;

        if (this.app === undefined) {
            this.app = this.injector.get(AppService);
        }
        if (this.app !== undefined) {
            const token = this.app.getToken();
            if (token !== '') {
                let tokenValue = 'Bearer ' + token;
                requestToForward = req.clone({ setHeaders: { Authorization: tokenValue } });
            }
        } else {
            console.debug('AppService undefined: NO auth header!');
        }

        return next.handle(requestToForward);
    }
}
